import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';

const Code = props => {
  const {
    className
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["className"]);

  return /*#__PURE__*/_jsx("code", Object.assign({}, rest, {
    className: classNames(className, 'private-code')
  }));
};

export default Code;
Code.displayName = 'Code';